import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import RootLayout from '@/layouts/RootLayout.vue';

/**
 * 用户-模块
 */
var user = {
  path: '/user',
  component: RootLayout,
  redirect: '/login',
  children: [{
    path: '/login',
    name: 'Login',
    component: function component() {
      return import('views/user/Login');
    },
    meta: {
      title: '登录'
    }
  },
  // {
  //   path: '/register',
  //   name: 'Register',
  //   component: () => import('views/user/Register'),
  //   meta: {
  //     title: '登录'
  //   }
  // },
  {
    path: '/password',
    name: 'Password',
    component: function component() {
      return import('views/user/Password');
    }
  }, {
    path: '/thirdPartyLogin',
    name: 'ThirdPartyLogin',
    component: function component() {
      return import('views/user/thirdPartyLogin');
    },
    meta: {
      title: '海星登录'
    }
  }]
};
export default user;